import { cn } from "@discovery/classnames";
import * as styles from "./styles.css";
import { Icon, Icons } from "../icon";
import { goBackToPreviousPage } from "../../../utils/common";
import { getIsMobile } from "../../../utils/isMobile";
export var BackButtonVariant;
(function (BackButtonVariant) {
    BackButtonVariant["WithBackground"] = "withBackground";
})(BackButtonVariant || (BackButtonVariant = {}));
export const BackButton = ({ children, variant, customStyle, customBackNavigation = false, goBackTo, }) => {
    return (React.createElement(React.Fragment, null, getIsMobile() && (React.createElement("div", { className: cn(styles.container, customStyle, {
            [styles.withBackground]: variant === BackButtonVariant.WithBackground,
        }) },
        React.createElement("div", { className: styles.goBack, onClick: customBackNavigation ? goBackTo : goBackToPreviousPage },
            React.createElement(Icon, { type: Icons.LeftArrow, className: styles.backArrow })),
        React.createElement("div", { className: styles.header }, children)))));
};

